import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutV4 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="ltn__about-us-area pt-120--- pb-90 mt--30 go-top">
				<div className="container">
				<div className="row">
					<div className="col-lg-6 align-self-center">
					<div className="about-us-img-wrap about-img-left">
						<img src={publicUrl+"assets/img/others/13.png"} alt="About Us Image" />
						<div className="about-us-img-info about-us-img-info-2 about-us-img-info-3">
						{/* <div className="ltn__video-img ltn__animation-pulse1">
							<img src={publicUrl+"assets/img/others/8.png"} alt="video popup bg image" />
							<a className="ltn__video-icon-2 ltn__video-icon-2-border---" href="https://www.youtube.com/embed/X7R-q9rsrtU?autoplay=1&showinfo=0" data-rel="lightcase:myCollection">
							<i className="fa fa-play" />
							</a>
						</div> */}
						</div>
					</div>
					</div>
					<div className="col-lg-6 align-self-center">
					<div className="about-us-info-wrap">
						<div className="section-title-area ltn__section-title-2--- mb-20">
						<h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">About Us</h6>
						<h1 className="section-title">The Trusted Partner in Farm Plot Development<span>.</span></h1>
						<p>Over 500+ families have trusted AVS Enterprises for their real estate investment journey.
						We combine legal assurance, infrastructure quality, and location advantage — all in one offering.</p>
						</div>
						<ul className="ltn__list-item-half clearfix">
						<li>
							{/* <i className="flaticon-home-2" /> */}
							<img src={publicUrl+"assets/img/icons/icon-img/Planned-Layouts.svg"} alt="icon" style={{ borderRadius: '50%'}} />
							Thoughtfully Planned Layouts
						</li>
						<li>
							{/* <i className="flaticon-mountain" /> */}
							<img src={publicUrl+"assets/img/icons/icon-img/Proximity-to-Urban-Growth-Zones.svg"} alt="icon" style={{ borderRadius: '50%'}} />
							Proximity to Urban Growth Zones
						</li>
						<li>
							{/* <i className="flaticon-heart" /> */}
							<img src={publicUrl+"assets/img/icons/icon-img/Verified-Documentation-Clear-Titles.svg"} alt="icon" style={{ borderRadius: '50%'}} />
							Verified Documentation & Clear Titles
						</li>
						<li>
							{/* <i className="flaticon-secure" /> */}
							<img src={publicUrl+"assets/img/icons/icon-img/Modern-Infrastructure-Amenities.svg"} alt="icon" style={{ borderRadius: '50%'}} />
							Modern Infrastructure & Amenities
						</li>
						</ul>
						<div className="ltn__callout bg-overlay-theme-05  mt-30">
						<p>"A reliable name in plotted development since 2015,
						AVS delivers legally clear, nature-rich living spaces."
						</p>
						</div>
						<div className="btn-wrapper animated">
						<Link to="/shop" className="theme-btn-1 btn btn-effect-1" style={{ borderRadius: '10px'}} >OUR PROJECTS</Link>
						</div>
					</div>
					</div>
				</div>
				</div>
			</div>
        }
}

export default AboutV4